import React, { useState } from "react";
import PropTypes from "prop-types";
import { IconButton, makeStyles, Typography, withStyles } from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import InfoIcon from "@material-ui/icons/Info";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  alignText: {
    padding: "20px",
    whiteSpace: "pre-line",
  },
  popoverRootElement: {
    "& > *": {
      maxWidth: "500px",
      maxHeight: "200px",
      marginRight: "10px",
      marginBottom: "30px",
    },
  },
  iconButton: {
    padding: 6,
    marginLeft: 5,
    "&:hover": {
      opacity: 0.6,
    },
  },
}));

const InformationTag = (props) => {
  const classes = useStyles(props);

  const handleClose = () => {
    setAnchorElement(null);
  };

  const handleToggle = (event) => {
    setAnchorElement(event.target);
  };

  const [anchorElement, setAnchorElement] = useState(null);
  const open = Boolean(anchorElement);
  return (
    <React.Fragment>
      <IconButton classes={{ root: classes.iconButton }} onClick={handleToggle}>
        <InfoIcon></InfoIcon>
      </IconButton>
      <Popover
        className={classes.popoverRootElement}
        onClose={handleClose}
        onClick={handleClose}
        open={open}
        anchorEl={anchorElement}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Typography className={clsx(classes.alignText, "popoverBorder")}>{props.infoText}</Typography>
      </Popover>
    </React.Fragment>
  );
};

InformationTag.propTypes = {
  infoText: PropTypes.string,
  classes: PropTypes.object,
};
export default InformationTag;
